import { KLAGE_MILJOKONTROLL_IMAGE } from "../actions/klager/klageAction";
import { CreateNewReducer } from "../utils/reducerUtils";

const INITIAL_STATE = [];

const klageMiljoKontrollImageReducer = (state = INITIAL_STATE, action) =>
  CreateNewReducer(state, action, KLAGE_MILJOKONTROLL_IMAGE);

export default klageMiljoKontrollImageReducer;
